import { jwtDecode } from "jwt-decode";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { clientStorage } from "./dummyEngine";

type Role = "SuperAdmin" | "Admin";

interface TokenData {
  aud: string;
  exp: number;
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": string;
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": string;
  iss: string;
  nbf: number;
  role: Role;
  name: string;
  id: string;
}

export function decode(token: string) {
  const data = jwtDecode<TokenData>(token);
  return {
    ...data,
    role: data[
      "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
    ] as Role,
    name: data["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"],
    id: data[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
    ],
  };
}

export type AuthStore = {
  accessToken: string;
  refreshToken: string;
  login: (accessToken: string, refreshToken: string) => void;
  logout: () => void;
  isAuthenticated: boolean;
  user?: TokenData;
};

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      accessToken: "",
      refreshToken: "",
      login: (accessToken, refreshToken) =>
        set({
          accessToken,
          refreshToken,
          isAuthenticated: true,
          user: decode(accessToken),
        }),
      logout: () =>
        set({
          accessToken: "",
          refreshToken: "",
          isAuthenticated: false,
          user: undefined,
        }),
      isAuthenticated: false,
      user: undefined,
    }),
    {
      name: "auth-store",
      storage: createJSONStorage(() => clientStorage),
    },
  ),
);

export type UseAuthStore = typeof useAuthStore;
